import { useNavigate } from "react-router-dom";
import { ArrowLeft, LogOut, UserRound } from "lucide-react";
import { getProfile, clearAuth } from "./api";

export const Panel = ({ children, className = "", ...rest }) => (
  <div className={`rounded-2xl bg-[#141414] border border-white/10 ${className}`} {...rest}>{children}</div>
);

export const BigBtn = ({ children, className = "", ...rest }) => (
  <button
    className={`w-full min-h-[52px] rounded-xl bg-[#ff2e4d] text-black font-bold uppercase tracking-wide text-base active:scale-[0.98] transition disabled:opacity-40 disabled:cursor-not-allowed ${className}`}
    {...rest}
  >{children}</button>
);

export const GhostBtn = ({ children, className = "", ...rest }) => (
  <button
    className={`min-h-[44px] rounded-xl border border-white/20 text-white/90 px-4 text-sm font-semibold active:scale-[0.98] transition disabled:opacity-40 ${className}`}
    {...rest}
  >{children}</button>
);

export const Field = ({ label, children }) => (
  <label className="block space-y-1.5">
    <span className="text-xs uppercase tracking-widest text-white/50">{label}</span>
    {children}
  </label>
);

export const inputCls =
  "w-full min-h-[48px] rounded-xl bg-black/40 border border-white/15 px-4 text-white text-base outline-none focus:border-[#ff2e4d] placeholder:text-white/30";

export const Spinner = () => (
  <div className="flex justify-center py-10">
    <div className="h-8 w-8 rounded-full border-2 border-white/20 border-t-[#ff2e4d] animate-spin" />
  </div>
);

export function Shell({ title, back, children, wide }) {
  const nav = useNavigate();
  const profile = getProfile();
  const w = wide ? "max-w-6xl" : "max-w-xl";
  return (
    <div className="min-h-screen bg-[#050505] text-white" style={{ fontFamily: "Archivo, sans-serif" }}>
      <header className="sticky top-0 z-40 bg-[#050505]/90 backdrop-blur border-b border-white/10">
        <div className={`mx-auto ${w} px-4 h-14 flex items-center gap-3`}>
          {back && (
            <button data-testid="staff-back-button" onClick={() => nav(back)}
              className="h-11 w-11 -ml-2 flex items-center justify-center rounded-lg active:bg-white/10" aria-label="Back">
              <ArrowLeft size={20} />
            </button>
          )}
          <div className="flex-1 min-w-0">
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#ff2e4d] leading-none">Staff space</p>
            <h1 className="font-bold text-lg truncate" style={{ fontFamily: "Anton, sans-serif", letterSpacing: "0.03em" }}>{title}</h1>
          </div>
          {profile?.name && (
            <div className="flex items-center gap-1">
              <span data-testid="active-staff-name" className="hidden sm:flex items-center gap-1.5 text-xs text-white/60 mr-1">
                <UserRound size={14} /> {profile.name} · {profile.role}
              </span>
              <button data-testid="staff-logout-button" aria-label="Log out"
                onClick={() => { clearAuth(); nav("/staff/entry"); }}
                className="h-11 w-11 flex items-center justify-center rounded-lg active:bg-white/10 text-white/60">
                <LogOut size={18} />
              </button>
            </div>
          )}
        </div>
      </header>
      <main className={`mx-auto ${w} px-4 py-5 pb-28`}>{children}</main>
    </div>
  );
}
